import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  card: {
    padding: theme.spacing(2),
    backgroundColor: '#ffffff',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    border: '1px solid #EBEBEB',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    },
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: 198,
    borderRadius: 5,
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      height: 312,
    },
  },
  image: {
    objectFit: 'cover',
    overflow: 'hidden',
  },
  title: {
    fontSize: 20,
    fontFamily: theme.gh_vars.circular,
    fontWeight: 600,
    color: '#080808',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      fontSize: 24,
    },
  },
  address: {
    fontSize: 16,
    fontFamily: theme.gh_vars.circular,
    fontWeight: 600,
    color: '#080808',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: theme.spacing(0.5),
  },
  cityState: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    height: 25,
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 12,
    fontStyle: 'normal',
    fontFamily: theme.gh_vars.circular,
    fontWeight: 600,
    color: '#666666',
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
      marginTop: theme.spacing(0.25),
    },
  },
}));
